import React, {useEffect} from "react";
import {useConversionEvent} from '../hooks/useConversionEvent'
/**
 * References 👇🏾:
 *  1. Forms.create API Reference => https://developers.hubspot.com/docs/cms/building-blocks/forms
 *  2. Hubspot Form React Integration => https://community.hubspot.com/t5/APIs-Integrations/HELP-Embed-a-form-in-a-React-component/m-p/520436/highlight/true#M48362
 */

const HubspotContactForm = () => {

    const sendGTMEvent = useConversionEvent()

    useEffect(() => {
        const script = document.createElement('script');
        script.src='//js.hsforms.net/forms/embed/v2.js';
        script.async = true;
        document.body.appendChild(script);

        script.addEventListener('load', () => {
            // @TS-ignore
            if (window.hbspt) {
                // @TS-ignore
                window.hbspt.forms.create({
                    region: "na1", portalId: process.env.GATSBY_HUBSPOT_PORTAL_ID, formId: process.env.GATSBY_HUBSPOT_FORM_ID,
                    target: '#hubspotForm',
                    onFormSubmit: ()=> sendGTMEvent({type: "event", eventName: "contact_us_form_submitted"})
                })
            }
        });
    }, []);

    return (
        <div>
            <div id="hubspotForm"></div>
        </div>
    );

}

export default HubspotContactForm;
